module.exports = __webpack_public_path__ + "static/w_x-344955573b6eb500cea5ee2d324c04c2.png";